module.exports = __webpack_public_path__ + "4_Messaging_withoutNavHeader-765edee2827746924f4d762b914bdcf1.png";